<template>
  <el-dialog
    v-model="dialogVisible"
    title="登录"
    width="500"
    append-to-body
  >
    <div class="ac">
      <img src="@/assets/images/mp-qrcode.jpg">
      <div class="mt20">登录小程序查看更多</div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import bus from "@/utils/eventBus"

const dialogVisible = ref(false)

onMounted(() => {
  bus.on('showLoginDialog', () => {
    dialogVisible.value = true
  })
})
</script>